import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_VenInfos/Load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_VenInfos/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_VenInfos/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_VenInfos/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_VenInfos/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_VenInfos/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_VenInfos/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
